// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Jmb1","rootSuccess":"CompleteLink_rootSuccess__2LZg8","rootFailure":"CompleteLink_rootFailure__2AZfG","isDisabled":"CompleteLink_isDisabled__3HNz7"};